<itl-textarea
  [(ngModel)]="text"
  [required]="node.mandatory"
  [title]="node.title"
  [description]="node.description"
  [maxlength]="showCharacterLimit ? characterLimit : null"
  [icon]="node.globalType ? (node.globalType | globalTypeIcon) : null"
>
</itl-textarea>
